var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-field',{attrs:{"id":_vm.id,"label":_vm.label,"variant":_vm.variant,"error":_vm.error,"labelPosition":_vm.labelPosition,"bottom-margin":_vm.bottomMargin}},[_c('ui-range-input',_vm._g({attrs:{"id":_vm.id,"readonly":_vm.readonly,"value":_vm.value,"required":_vm.required,"min":_vm.min,"max":_vm.max,"step":_vm.step}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }